import React from 'react';

const OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
];

export default function LanguagePreferenceToggle({ value = 'en', onChange, disabled = false }) {
  const selected = value === 'es' ? 'es' : 'en';

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">Language</label>
      <div className="inline-flex gap-2">
        {OPTIONS.map((opt) => {
          const active = selected === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              disabled={disabled}
              onClick={() => onChange(opt.value)}
              className={`px-4 py-2 text-sm font-medium rounded-md border transition-all disabled:opacity-50 ${
                active
                  ? 'bg-[#00AAFF] text-white border-[#00AAFF]'
                  : 'bg-white text-gray-600 border-gray-300 hover:border-[#00AAFF]/40'
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
